'use client';

import { SessionProvider } from 'next-auth/react';

/** Seconds between session polls while focused; keeps client JWT in sync with server refresh. */
const SESSION_REFETCH_INTERVAL_SEC = 240;

export default function AuthSessionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SessionProvider
      refetchInterval={SESSION_REFETCH_INTERVAL_SEC}
      refetchOnWindowFocus
    >
      {children}
    </SessionProvider>
  );
}


